if (!customElements.get('squishlab-page')) {
  customElements.define('squishlab-page', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.main = document.querySelector('product-info:has(.sq-buybox)');
      this.primary = this.main?.querySelector('button[name="add"]');
      this.form = this.primary?.form;
      this.sticky = this.querySelector('[data-sq-sticky]');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelectorAll('[data-sq-purchase]').forEach(button => {
        button.addEventListener('click', event => {
          if (!this.primary || !this.form || this.primary.disabled) return;
          event.preventDefault();
          this.form.requestSubmit(this.primary);
          this.main.scrollIntoView({ block: 'start', behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
        }, options);
      });
      this.videos = [...this.querySelectorAll('video[data-sq-proof], video[data-sq-motion]')];
      this.videos.forEach(video => {
        video.controls = false;
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;
      });
      if (this.primary && this.sticky) {
        this.purchaseObserver = new IntersectionObserver(entries => {
          const entry = entries[0];
          this.sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        }, { threshold: 0 });
        this.purchaseObserver.observe(this.primary);
        this.buttonObserver = new MutationObserver(() => this.syncButtons());
        this.buttonObserver.observe(this.primary, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
        this.syncButtons();
      }
      this.motionObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        const video = entry.target;
        video.dataset.sqInView = String(entry.isIntersecting && entry.intersectionRatio >= 0.15);
        this.syncVideo(video);
      }), { threshold: [0, 0.15] });
      this.videos.forEach(video => this.motionObserver.observe(video));
      document.addEventListener('visibilitychange', () => this.videos.forEach(video => this.syncVideo(video)), options);
      this.reducedMotion.addEventListener('change', () => this.videos.forEach(video => this.syncVideo(video)), options);
      const error = this.main?.querySelector('.product-form__error-message-wrapper');
      if (error) {
        this.errorObserver = new MutationObserver(() => {
          if (!error.hidden && error.getAttribute('hidden') === null) this.main.scrollIntoView({ block: 'center' });
        });
        this.errorObserver.observe(error, { attributes: true, attributeFilter: ['hidden'] });
      }
    }
    syncVideo(video) {
      if (video.dataset.sqInView !== 'true' || this.reducedMotion.matches || document.hidden) {
        video.pause();
        return;
      }
      const source = video.querySelector('source[data-sq-src]');
      if (source) {
        source.src = source.dataset.sqSrc;
        delete source.dataset.sqSrc;
        video.load();
      }
      video.play().catch(() => {});
    }
    syncButtons() {
      this.querySelectorAll('[data-sq-purchase]').forEach(button => {
        button.setAttribute('aria-disabled', String(this.primary.disabled));
      });
    }
    disconnectedCallback() {
      this.videos?.forEach(video => video.pause());
      this.abort?.abort();
      this.purchaseObserver?.disconnect();
      this.motionObserver?.disconnect();
      this.buttonObserver?.disconnect();
      this.errorObserver?.disconnect();
    }
  });
}
